import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { FlatList } from 'types/api'
import { BaseParams, BaseResponse } from 'types/utils'

export const flatsQueryKey = ['flats']

export function useFlats({
  params
}: BaseParams<{ limit?: number; status?: FlatList['status'] | FlatList['status'][]; landlord_id?: string }> = {}) {
  const [searchParams] = useSearchParams()
  const search = searchParams.get('search')
  const ordering = searchParams.get('ordering')
  const limit = params?.limit ?? searchParams.get('limit')
  const offset = searchParams.get('offset')
  const status = searchParams.get('status')
  const min_rent = searchParams.get('min_rent')
  const max_rent = searchParams.get('max_rent')
  const onboarded = searchParams.get('onboarded')
  const location = searchParams.get('location')

  async function fetchFlats() {
    const res = await apiClient.get<BaseResponse<FlatList>>(
      `${SNA_PREFIX}flats`,
      {
        params: {
          search,
          ordering,
          limit,
          offset,
          status: params?.status ?? status,
          landlord_id: params?.landlord_id,
          min_rent,
          max_rent,
          onboarded,
          location
        }
      }
    )
    return res.data
  }

  return useQuery({
    queryKey: [
      ...flatsQueryKey,
      search,
      ordering,
      limit,
      offset,
      params?.status ?? status,
      params?.landlord_id,
      min_rent,
      max_rent,
      onboarded,
      location
    ],
    queryFn: fetchFlats
  })
}
